import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const tiveConfig: TSPConfig = {
  key: 'tive',
  name: 'Tive',
  category: TSPCategory.CUSTOM,
  helpText: (
    <ol>
      <li>
        Follow the instructions to generate a Client ID and Client Secret at
        this URL:{' '}
        <a
          href='https://developers.tive.com/docs/authentication'
          rel='noreferrer'
          target='_blank'
        >
          https://developers.tive.com/docs/authentication
        </a>
      </li>
      <li>Input the generated Client ID and Client Secret here.</li>
    </ol>
  ),
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'Client ID', name: 'database', type: 'text', required: true },
        {
          label: 'Client Secret',
          name: 'authorizationcode',
          type: 'password',
          required: true,
        },
      ]}
    />
  ),
};

export default tiveConfig;
